// Module
var code = "<mx-text-area ng-model=\"vm.condition.value\" ng-required=\"true\" mx-expression-validator=\"vm.condition._options.EntityClassName\" expression-type=\"StringType\" is-condition=\"true\"></mx-text-area>";
// Exports
export default code;